import { gsap } from 'gsap';
import { Container, Sprite, Texture } from '../../../odie';

import { BasicBlockProps, ColorId } from '../../defs/block';
import { SymbolId, newSymbolMap, symbolMap } from '../../defs/symbol';
import { blockPositionView } from '../../util/blockTools';
import { BombBlockView } from './BombBlockView';
import { CubeBlockView } from './CubeBlockView';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';
import { RocketBlockView } from './RocketBlockView';

// constants
//-------------------------------------------------------------------------
const colorMap: { [key in ColorId]?: string } = {
  blue: 'basic/block.basic.blue.png',
  green: 'basic/block.basic.green.png',
  purple: 'basic/block.basic.purple.png',
  red: 'basic/block.basic.red.png',
  yellow: 'basic/block.basic.yellow.png',
};

/*
    basic block view
*/
export class BasicBlockView extends Container {
  // fields
  //-------------------------------------------------------------------------
  // state
  private _symbolId!: SymbolId;
  // scene
  private _symbolSprite: Sprite;

  // properties
  //-------------------------------------------------------------------------
  public get symbolId(): SymbolId {
    return this._symbolId;
  }

  public set symbolId(symbolId: SymbolId) {
    if (this._symbolId === symbolId) return;
    // update field
    this._symbolId = symbolId;

    // update texture
    this._symbolSprite.texture = Texture.from(newSymbolMap[symbolId].asset);
    this._symbolSprite.x = 0;
    this._symbolSprite.y = 2;

    gsap.fromTo(
      this._symbolSprite,
      { scaleX: 0, scaleY: 0 },
      { scaleX: 1, scaleY: 1, duration: 0.35, ease: 'back.out' },
    );
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: BasicBlockProps) {
    if (!props.color) throw new Error('[BasicBlockView] color is required');
    // create base view
    super();
    const sprite = new FitWidthBlockSprite(colorMap[props.color] ?? '', props);
    this.addChild(sprite);
    blockPositionView(this, props);

    // create symbol sprite
    this._symbolSprite = new Sprite();
    // sprite.blendMode = BLEND_MODES.MULTIPLY;
    this._symbolSprite.anchorX = 0.5;
    this._symbolSprite.anchorY = 0.5;

    // spawn
    sprite.addChild(this._symbolSprite);
  }

  public static assets(props: BasicBlockProps) {
    if (!props.color) throw new Error('[BasicBlockView] color is required');
    return [
      colorMap[props.color] ?? '',
      'fx.basic/',
      'fx.block/',
      'fx.combo/',
      ...BombBlockView.assets(),
      ...RocketBlockView.assets(),
      ...CubeBlockView.assets({ color: props.color }),
      'symbols/',
    ];
  }
}
